export function taxFixedMethodCodes(): string[] {
  return ['TAF', 'TDFN']
}

export function taxSaleCodes(): string[] {
  return ['NO_VAT', 'V81', 'V26', 'V38', 'V250.81', 'V250.26', 'V250.38', 'V0E', 'V0I', 'ANN', 'V0N', 'V0H']
}

export function taxSaleZeroCodes(): string[] {
  return ['NO_VAT', 'V0E', 'V0I', 'ANN', 'V0N', 'V0H']
}

export function taxPurchaseCodes(): string[] {
  return ['I81', 'I26', 'I38', 'IND0', 'IND81', 'IND38', 'IND26', 'RC81', 'RC26', 'RC38']
}

export function taxPurchaseRecoverableCodes(): string[] {
  return ['I81', 'I26', 'I38']
}

export function taxPurchaseNonDeductibleCodes(): string[] {
  return ['IND0', 'IND81', 'IND38', 'IND26']
}

export function taxPurchaseReverseChargeCodes(): string[] {
  return ['RC81', 'RC26', 'RC38']
}
